import React, { useState } from 'react';
import { Col, Input, Row } from 'antd';
import { Controller, useFormContext } from 'react-hook-form';

const WaitTimeInput = () => {
  const { control } = useFormContext();
  const [validTimeRange, setValidTimeRange] = useState(true);

  return (
    <Controller
      control={control}
      name="waitTime"
      render={({ field: { value, onChange } }) => {
        return (
          <>
            <Row>
              <Col span={14}>
                <Input
                  addonBefore="Keep mails opened for about"
                  min={1}
                  required
                  type="number"
                  value={value.from}
                  onBlur={e => {
                    const from = parseInt(e.target.value);
                    setValidTimeRange(from < value.to);
                  }}
                  onChange={e => {
                    onChange({
                      ...value,
                      from: parseInt(e.target.value),
                    });
                  }}
                />
              </Col>

              <Col span={10}>
                <Input
                  addonAfter="seconds"
                  addonBefore="to"
                  min={1}
                  placeholder="Time"
                  required
                  type={'number'}
                  value={value.to}
                  onBlur={e => {
                    const to = parseInt(e.target.value);
                    setValidTimeRange(to > value.from);
                  }}
                  onChange={e => {
                    onChange({
                      ...value,
                      to: parseInt(e.target.value),
                    });
                  }}
                />
              </Col>
            </Row>

            <div className="error-text">
              {!validTimeRange
                ? 'Invalid time range (From greater or equal to To)'
                : ''}
            </div>
          </>
        );
      }}
      rules={{
        validate: ({ from, to }: { from: number, to: number }) => {
          return (from == 0 && to == 0) || to > from;
        },
      }}
    />
  );
};

export default WaitTimeInput;
